import { useState } from "react";
import { Link } from "react-router-dom";
import { getHistory, clearHistory } from "@/lib/bank";
import { PASS_SCORE } from "@/lib/scoring";
import { useAuth } from "@/context/AuthContext";
import { ScoreTrend } from "@/components/ScoreTrend";
import { mockTitle, mixLabel } from "@/data/mocks";
import { WeakSpotCard } from "@/components/WeakSpot";

export default function History() {
  const [hist, setHist] = useState(getHistory());
  const { user } = useAuth();
  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-8">
      <h1 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">Exam History</h1>
      <p className="mt-2 text-slate-400">{user ? "Synced to your account and saved in this browser." : "Saved in this browser. Sign in to keep it across devices."}</p>
      {hist.length > 0 && <div className="mt-8 grid gap-4 lg:grid-cols-[1.6fr_1fr]"><ScoreTrend hist={hist} /><WeakSpotCard /></div>}
      <div className="mt-8 overflow-hidden rounded-xl bg-white shadow-xl">
        {hist.length === 0 ? (
          <div data-testid="history-empty" className="p-10 text-center text-slate-500">No exams yet. <Link to="/mock" className="font-semibold text-indigo-600 hover:underline">Start a mock exam</Link></div>
        ) : (
          <table className="w-full text-sm" data-testid="history-table">
            <thead className="bg-slate-50 text-left font-mono text-[10px] uppercase tracking-widest text-slate-500">
              <tr><th className="p-4">Exam</th><th className="p-4">Date</th><th className="p-4">Score</th><th className="p-4">Result</th><th className="p-4" /></tr>
            </thead>
            <tbody>
              {hist.map((h) => (
                <tr key={h.id} data-testid={`history-row-${h.id}`} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="p-4 font-medium text-slate-800">{mockTitle(h)}{mixLabel(h) && <div data-testid={`history-mix-${h.id}`} className="font-mono text-xs font-normal text-slate-500">{mixLabel(h)}</div>}</td>
                  <td className="p-4 text-slate-500">{new Date(h.date).toLocaleString()}</td>
                  <td className="p-4 font-display text-xl font-bold text-slate-900">{h.overall}</td>
                  <td className="p-4"><span className={`rounded-full px-2 py-1 text-xs font-bold ${h.overall >= PASS_SCORE ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}>{h.overall >= PASS_SCORE ? "Met target" : "Below target"}</span></td>
                  <td className="p-4 text-right"><Link to={`/report/${h.id}`} data-testid={`history-view-${h.id}`} className="font-semibold text-indigo-600 hover:underline">View report</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {hist.length > 0 && <button data-testid="history-clear-btn" onClick={() => { if (window.confirm("Clear local history?")) { clearHistory(); setHist([]); } }} className="mt-4 text-xs text-slate-500 underline hover:text-slate-300">Clear local history</button>}
    </div>
  );
}
